import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaHistory, FaCircle } from 'react-icons/fa';
import DataTable from '../shared/DataTable';
import Loader from '../../shared/Loader';

const AuditLog = () => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLogs = async () => {
            try {
                const res = await axios.get('/api/admin/audit-logs', {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                });
                setLogs(res.data);
                setTimeout(() => {
                    setLoading(false);
                }, 500);
            } catch (err) {
                console.error("Error fetching audit logs", err);
                setTimeout(() => {
                    setLoading(false);
                }, 500);
            }
        };
        fetchLogs();
    }, []);

    const columns = [
        { header: 'Action', key: 'action', width: '15%' },
        {
            header: 'User',
            key: 'user',
            width: '20%',
            render: (row) => (
                <span style={{ fontWeight: 600, color: 'var(--primary-blue)' }}>{row.user}</span>
            )
        },
        { header: 'Details', key: 'details', width: '30%' },
        {
            header: 'Status',
            key: 'status',
            width: '12%',
            render: (row) => (
                <span className={`status-badge ${row.status}`}>
                    <FaCircle style={{ fontSize: '8px', marginRight: '6px' }} />
                    {row.status.toUpperCase()}
                </span>
            )
        },
        {
            header: 'IP Address',
            key: 'ip',
            width: '13%',
            render: (row) => <code style={{ fontSize: '12px' }}>{row.ip || '---'}</code>
        },
        {
            header: 'Timestamp',
            key: 'timestamp',
            width: '10%',
            render: (row) => (
                <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
                    <div>{new Date(row.timestamp).toLocaleDateString()}</div>
                    <div style={{ fontWeight: 600 }}>{new Date(row.timestamp).toLocaleTimeString()}</div>
                </div>
            )
        },
    ];

    if (loading) {
        return <Loader />;
    }

    return (
        <div className="audit-log fade-in">
            <div className="dashboard-header">
                <h1 className="page-title">Security Audit Log</h1>
                <p className="page-subtitle">Monitoring high-fidelity system events and administrative traces.</p>
            </div>

            <DataTable
                title="System Activity Log"
                columns={columns}
                data={logs}
                filterOptions={[
                    { label: 'Completed', value: 'completed' },
                    { label: 'Pending', value: 'pending' },
                    { label: 'Warning', value: 'warning' },
                    { label: 'Failed', value: 'failed' }
                ]}
            />
        </div>
    );
};

export default AuditLog;
